/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import Icon from 'components/Icon';
import Text from 'components/Text';
import { MEDIA_QUERIES } from 'styles/constants';
import PartyFeek from 'assets/images/PartyFeek.png';
import { PURPLE_ELECTRIC, PURPLE_MEDIUM, WHITE } from 'styles/colors';
import { ReactComponent as CheckCircleOutline } from 'assets/icons/CheckCircleOutline.svg';

const styles = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #4f12b8;
  background: linear-gradient(
    176deg,
    rgba(79, 18, 184, 1) 0%,
    rgba(101, 45, 196, 1) 35%,
    rgba(54, 10, 125, 1) 100%
  );

  h1,
  h2,
  h3 {
    margin: 0;
  }

  .content {
    margin: 0 auto;
    flex: 1;
    padding: 16px 40px;
    // background: ${PURPLE_ELECTRIC};
    box-sizing: border-box;
    b {
      color: ${WHITE};
    }
  }

  img {
    box-sizing: border-box;
    height: 100%;
  }

  .items-list-container {
    display: flex;
    flex-direction: row;
    gap: 70px;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 40px;
    width: fit-content;
  }

  .itemlist {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 4px;
  }

  ${MEDIA_QUERIES.smallScreen} {
    flex-direction: column;

    .content {
      padding: 70px 20px;
    }

    img {
      width: 100%;
    }
  }
`;

export const FeekFeatures = () => {
  return (
    <div css={styles}>
      <img src={PartyFeek} alt="Party Feek" />
      <div className="content">
        <Text type="h2" color={PURPLE_MEDIUM} fontSize={38}>
          Con <b>Feek</b> también tienes acceso a
        </Text>
        <div className="items-list-container">
          <div>
            <ItemList title="Capacitación" />
            <ItemList title="Notificaciones de reservación" />
            <ItemList title="Consultoría de campañas" />
          </div>
          <div>
            <ItemList title="Soporte personalizado" />
            <ItemList title="Reporte de resultados" />
            <ItemList title="Y mucho más" />
          </div>
        </div>
      </div>
    </div>
  );
};

const ItemList = ({ title }) => {
  return (
    <div className="itemlist">
      <Icon icon={CheckCircleOutline} color={PURPLE_MEDIUM} />
      <Text color={PURPLE_MEDIUM} fontSize={18}>
        {title}
      </Text>
    </div>
  );
};

ItemList.propTypes = {
  title: PropTypes.string.isRequired,
};
